import React, { useCallback, useState, useMemo, useEffect } from 'react';
import DialogBox from './DialogBox';
import AgentAccessDialog from './AgentAccessDialog';
import { createRoot } from 'react-dom';
import { copyToClipboard, qrToast } from './includes/utils';
import { FaCopy, FaQrcode } from 'react-icons/fa';
import { format } from 'mathjs';

const TitleBar = ({
	title = "Program Manager",
	showMinMax = true,
	onContextMenu,
	onMinimize,
	onMaximize,
	onClose,
	onHelp,
	isMaximized,
	onClick,
	appData,
	icon,
	isActiveWindow,
	embedable,
	embeded,
	metadata,
	windowA,
	...rest
}) => {
	// console.log('TitleBar', title, appData, rest);
	const handleMaximize = useCallback(() => {
		if (onMaximize) {
			onMaximize(!isMaximized);
		}
	}, [isMaximized, onMaximize]);

	const { license, setAppDataKey, embedMode } = appData || {};

	// Built-in fallback context menu when no external handler is provided
	const [fallbackMenu, setFallbackMenu] = useState(null);

	const handleContextMenu = useCallback((e) => {
		const rect = e.target.getBoundingClientRect();
		const position = { x: rect.left, y: rect.bottom };
		if (onContextMenu) {
			onContextMenu(position);
		} else if (onClose) {
			// Show a minimal built-in context menu with Close
			setFallbackMenu(position);
		}
	}, [onContextMenu, onClose]);

	// Windows-style: double-clicking the control box on the left of
	// the title bar closes the window. We swallow the surrounding
	// single-click context-menu trigger on dblclick so the menu does
	// not flash open behind the closing window.
	const handleControlBoxDoubleClick = useCallback((e) => {
		e.stopPropagation();
		setFallbackMenu(null);
		if (onClose) onClose();
	}, [onClose]);


	const doSetAppData = useCallback((key, newData) => {
		if (!setAppDataKey) return;
		setAppDataKey(key, newData);
	}, [setAppDataKey]);
	const [shareOptions, setShareOptions] = useState();
	const [shareProgOptions, setShareProgOptions] = useState({});
	const [showDialog, setShowDialog] = useState(false);
	// "AI" button: agent access (MCP) info for this window's program.
	const [showAgentDialog, setShowAgentDialog] = useState(false);
	const openAgentDialog = useCallback(() => setShowAgentDialog(true), []);
	const closeAgentDialog = useCallback(() => setShowAgentDialog(false), []);

	const shareProgOptionsOptions = {
		'exchange.exe': [
			{ title: 'Thorchain affiliate Address', key: 'tcName', hint: 'Your Thorname, without the .thor', value: 'be', pattern: "[A-Za-z0-9]{5}" },
			{ title: 'Maya affiliate Address', key: 'mayaName', hint: 'Must be valid and registered.', value: 'be', pattern: "[A-Za-z0-9]{4}" }
		]
	};


	//Pop up a dialog box with the share options - use the window hash, split by /, if the last one has & then split by & give checkboxes for each
	//also an embed option if the window is embedable, which will give a text box with the embed code for the window in an iframe
	const share = useCallback(() => {
		// console.log('share', appData);
		const { hash } = window.location;
		const hashParts = hash.replace('#', '').split('/');
		const shareParts = hashParts[hashParts.length - 1].split('&');
		// console.log(shareParts);
		const oShareOptions = shareParts.map((part) => {
			if (!part) return null;

			const [key, value] = part.split('=');
			return { key, value, checked: true };
		});

		let progOptions = {};
		//go through all hashParts and find any .exe then add any program specific options
		hashParts.forEach((part, index) => {
			if (part.endsWith('.exe') && shareProgOptionsOptions[part]) {
				progOptions[part] = shareProgOptionsOptions[part];
			}
		});

		console.log('progOptions', progOptions);

		setShareProgOptions(progOptions);
		setShareOptions(oShareOptions);
		//dymamic share URL, based on the current window hash and the checcked share options
		setShowDialog(true);

	}
		, [shareProgOptionsOptions, appData]);


	const shareHash = useMemo(() => {
		if (!shareOptions) return '';
		const hashParts = window.location.hash.replace('#', '').split('/');
		const shareParts = hashParts[hashParts.length - 1].split('&');
		const newShareParts = shareParts.map((part, index) => {
			if (shareOptions[index] && shareOptions[index].checked) {
				return part;
			}
			return null;
		});
		let newHashParts = hashParts.slice(0, hashParts.length - 1);
		newHashParts.forEach((part, index) => {
			let pOpts = {};
			if (!part.includes('&') && shareProgOptions[part]) {

				shareProgOptions[part].forEach((progOption, index2) => {
					if (progOption.set) {
						pOpts[progOption.key] = progOption.value;
					}
				});
				if (Object.keys(pOpts).length) {
					//replace part with as base64encoded json added after the .exe and a ~
					newHashParts[index] = part + '~' + btoa(JSON.stringify(pOpts));
				}
			}
		});

		const newShareURL = newHashParts.join('/') + ((hashParts.length > 1) ? '/' : '') + newShareParts.filter((part) => part).join('&');
		return newShareURL;
	}, [shareOptions, shareProgOptions]);

	const siteName = window.location.hostname.includes('winbit')? 'https://WINBIT32.COM': window.location.origin;
	const shareURL = siteName + '/#' + shareHash;
	const embedURL = siteName + '/#~embedMode=true/' + shareHash;
	// console.log(shareOptions);
	const embedCode = `<iframe src="${embedURL}" width="465" height="800" style="border: none;" allow="clipboard-write, camera"></iframe>`;

	const openInNewTab = () => {
		const newTabJson = (metadata.phrase) ? JSON.stringify({ phrase: metadata.phrase }) : '';
		const newTabURL = newTabJson ? window.location.href.replace('winbit32', 'winbit32~' + btoa(newTabJson)) : window.location.href;
		console.log('newTabURL', newTabURL, window.location);
		window.open(newTabURL, '_blank');
	}


	return (
		<>
			<div className={'title ' + (isActiveWindow ? 'activewindow' : 'inactivewindow')}  {...rest} >
				{license ?
					<div
						onClick={handleContextMenu}
						onDoubleClick={handleControlBoxDoubleClick}
					>{icon}</div> :
					<div
						className="button close contextbutton"
						onClick={handleContextMenu}
						onDoubleClick={handleControlBoxDoubleClick}
					>
						&#8212;
					</div>
				}
				<div className='title-text' onDoubleClick={handleMaximize} onClick={onClick}>
					{title}{license && <> &nbsp; ᛝ</>}
				</div>



				{showMinMax && (
					<div className='maxmin' >
						{embedable && <>{!embedMode ? <div style={{float:'right'}}>Share →</div> : ''}<div
							className="button embed"
							onClick={() => {
								if (embedMode) {
									//bust out of embed mode into a new tab
									openInNewTab();
								} else {
									share();
								}
							}
							}
						>
							{!embedMode ? '⛓' : '⧉'}
						</div></>}
						{(!embedable || !embedMode) &&
							<>
								{license ? //Windows 95 style titlebar buttons
									<>
										<div
											className="button min"
											onClick={onMinimize}
										>
											&#128469;&#xFE0E;
										</div>
										<div
											className="button max"
											onClick={handleMaximize}
										>
											{isMaximized ? <>&#128471;&#xFE0E;</> : <>&#128470;&#xFE0E;</>}
										</div>
										<div
											className="button aibutton"
											onClick={openAgentDialog}
											title="Agent access (MCP)"
										>
											AI
										</div>
										{onHelp && (
											<div
												className="button help"
												onClick={onHelp}
												title="Help (F1)"
											>
												?
											</div>
										)}
										<div
											className="button titleclose"
											onClick={onClose}
										>
											&#128473;&#xFE0E;
										</div>
									</>
									:
									<>
										<div
											className="button aibutton"
											onClick={openAgentDialog}
											title="Agent access (MCP)"
											style={{ fontSize: 9, fontWeight: 'bold' }}
										>
											AI
										</div>
										{onHelp && (
											<div
												className="button help"
												onClick={onHelp}
												title="Help (F1)"
												style={{ fontSize: 11, fontWeight: 'bold' }}
											>
												?
											</div>
										)}
										<div
											className="button min"
											onClick={onMinimize}
										>
											▼
										</div>
										<div
											className="button max"
											onClick={handleMaximize}
										>
											{isMaximized ? '⬍' : '▲'}
										</div>
									</>
								}
							</>
						}
					</div>
				)}
			</div>
		{/* ── Built-in fallback context menu (Close) ── */}
		{fallbackMenu && (
			<div
				style={{
					position: 'fixed',
					top: fallbackMenu.y,
					left: fallbackMenu.x,
					zIndex: 99999,
					background: '#c0c0c0',
					borderTop: '2px solid #ffffff',
					borderLeft: '2px solid #ffffff',
					borderRight: '2px solid #000000',
					borderBottom: '2px solid #000000',
					boxShadow: '2px 2px 0 #000000',
					padding: '2px 0',
					minWidth: 120,
					fontFamily: "'System', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
					fontSize: 12,
				}}
			>
				<div
					style={{
						padding: '4px 24px 4px 24px',
						cursor: 'pointer',
						whiteSpace: 'nowrap',
					}}
					onMouseEnter={(e) => { e.currentTarget.style.background = '#000080'; e.currentTarget.style.color = '#ffffff'; }}
					onMouseLeave={(e) => { e.currentTarget.style.background = ''; e.currentTarget.style.color = ''; }}
					onClick={() => { setFallbackMenu(null); if (onClose) onClose(); }}
				>
					Close
				</div>
			</div>
		)}
		{fallbackMenu && (
			<div
				style={{ position: 'fixed', inset: 0, zIndex: 99998 }}
				onClick={() => setFallbackMenu(null)}
			/>
		)}
		{showAgentDialog && (
			<AgentAccessDialog
				progName={windowA?.progName}
				programTitle={windowA?.title || title}
				onClose={closeAgentDialog}
			/>
		)}
		{
			showDialog &&
			<DialogBox
				title="Share Options"
					modal={true}
					icon=""
					buttons={[{ label: 'Close', onClick: () => { setShowDialog(false) } }]}
					onClose={() => { setShowDialog(false) }}
					showMinMax={false}
				>
					<div className="share-dialog">
						<div>
							<span>Include<br />Options:</span>
							<div>
								{shareOptions.map((option, index) => (
									option &&
									<div key={index} className="share-option">
										<input type="checkbox" checked={option?.checked} onChange={(e) => {
											const newOptions = [...shareOptions];

											newOptions[index].checked = e.target.checked;
											setShareOptions(newOptions);
											console.log('shareOptions', shareOptions);
										}} />
										{option.key} {option.value && <small>{option.value}</small>}
									</div>
								))}
								{shareProgOptions && Object.keys(shareProgOptions).map((prog, index) => (
									shareProgOptions[prog].map((progOption, index2) => (
										<div key={index2} className="share-program-option">
											<span>{progOption.title}</span>
											<span>
												<div>
											<input type="text" value={progOption.value} onChange={(e) => {
												const newProgOptions = { ...shareProgOptions };
												newProgOptions[prog][index2].value = e.target.value;
												newProgOptions[prog][index2].set = true;
												setShareProgOptions(newProgOptions);
												
													}}
													pattern={progOption.pattern}
													
													/></div>
											{progOption.hint && <div className="hint">{progOption.hint}</div>}</span>
										</div>
									))))
								}

							</div>
						</div>
					<div>
						<span>Share URL:</span>
						<div><span><button onClick={() => copyToClipboard(shareURL)}> <FaCopy /></button> <button onClick={() => qrToast(shareURL)} ><FaQrcode /></button></span><span title={shareURL} className="share-url" onClick={ () => window.open(shareURL, '_blank' )}> <span className="selectable">{shareURL}</span></span></div>
					</div>
					<div>
						<span>Embed Code:</span>
						<textarea value={embedCode} readOnly />
					</div>
				</div>
		</DialogBox>

}
</>
		
	);
};

export default React.memo(TitleBar);
